<template>
  <div class="SrMoreText">
    <label
      :style="'width:' + (item.label ? item.labelWidth : 0) + 'px'"
      class="label-item ellipsis"
      ref="label"
      >{{ item.label }} {{ !hideColon ? "：" : "" }}</label
    >
    <span ref="SrMoreText" :class="['txt', hid ? 'hid' : 'show',importShow ? 'importShow':'']">{{
      txt
    }}</span>
    <template>
      <el-button class="btn" v-if="overflow" type="text" @click="open"
        >{{ btnTxt }}
        <i v-if="hid" :class="['el-icon-arrow-down', 'el-icon--right']"></i>
        <i v-else :class="['el-icon-arrow-up', 'el-icon--right']"></i
      ></el-button>
    </template>
  </div>
</template>

<!--
  功能：功能描述
  汪振涛
  时间：2021年02月25日 10:35:56
  版本：v1.0
-->
<script>
export default {
  model: {
    prop: "value",
    event: "change",
  },
  name: "SrMoreText",
  components: {},
  props: {
    value: String | Number,
    item: {
      type: Object,
      default: {},
    },
    hideColon: Boolean, // 隐藏冒号
  },
  data() {
    return {
      hid: null,
      txt: "",
      num: null,
      overflow: null,
      btnTxt: "展开",
      importShow:null
    };
  },
  watch: {
    value() {
      let divWidth = this.$refs.SrMoreText.offsetWidth; //盒子的宽度
      let txtLen = Math.ceil(divWidth / 21); //假设宽度243宽度的时候是21个中文
      let valHeight = this.value.length * txtLen; //文本的长度
      this.num = 3 * txtLen - Math.ceil(txtLen) / 5;
      let heightLen = Math.ceil(valHeight / divWidth); //行数
      
      
      if (3 < heightLen) {
        //如果文本溢出超过三行

        this.txt = this.value.substring(0, Math.ceil(this.num)) + "......";
        this.overflow = true; //已经溢出 显示展开
        this.hid = true; // 样式切换 收起
        
      } else {
        this.txt = this.value;
        this.hid = false; // 样式切换 展开
        this.importShow = true
      }
    },
  },
  methods: {
    change(value) {
      this.$emit("change", value);
    },
    open() {
      this.hid = !this.hid;
      this.btnTxt = this.hid ? "展开" : "收起";

      if (!this.hid) {
        this.txt = this.value;
      } else {
        this.txt = this.value.substring(0, Math.ceil(this.num)) + "......";
      }
    },
  },
  mounted() {
    let divWidth = this.$refs.SrMoreText.offsetWidth; //盒子的宽度
    let txtLen = Math.ceil(divWidth / 21); //假设宽度243宽度的时候是21个中文
    let valHeight = this.value.length * txtLen; //文本的长度
    this.num = 3 * txtLen - Math.ceil(txtLen) / 5;
    let heightLen = Math.ceil(valHeight / divWidth); //行数
    
    
    if (3 < heightLen) {
      //如果文本溢出超过三行

      this.txt = this.value.substring(0, Math.ceil(this.num)) + "......";
      this.overflow = true; //已经溢出 显示展开
      this.hid = true; // 样式切换 收起
      
    } else {
      this.txt = this.value;
      this.hid = false; // 样式切换 展开
      this.importShow = true 
    }
  },
};
</script>

<style scoped lang="scss">
.SrMoreText {
  display: flex;
  position: relative;
  .txt {
    flex: 1;
  }
  .btn {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 0;
  }
  .hid {
    height: 60px;
    overflow: hidden;
  }
  .show {
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// packages/SrMoreText/SrMoreText.vue